import { flag } from '@occc/data-flags';

export const featureFlagEditor = flag({
  key: 'feature-flag-control.editor',
  title: 'Feature Access Editor',
  description:
    'Grants access to the Feature Access editor, allowing administrators to view and manage per-user feature availability.',
  defaultValue: false,
});

export const driveChat = flag({
  key: 'drive.chat',
  title: 'AI-Powered Drive Chat',
  description:
    'Enables the AI-powered chat experience, providing intelligent conversational assistance for day-to-day operations.',
  defaultValue: false,
});
